import { Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IDatiqFeatureFlag } from '../../models';

import * as DatiqFeatureFlagSelectors from '../datiq-feature-flag.selectors';
import * as DatiqFeatureFlagActions from '../datiq-feature-flag.actions';
@Injectable({
    providedIn: 'root',
})
export class DatiqFeatureFlagStoreService {
    constructor(private _store: Store) {}

    useFlags$(): Observable<boolean> {
        return this._store.select(DatiqFeatureFlagSelectors.useFlags());
    }

    useFlagsSig(): Signal<boolean> {
        return this._store.selectSignal(DatiqFeatureFlagSelectors.useFlags());
    }

    areEnabled$(featureFlagKeys: string[]): Observable<boolean> {
        return this._store.select(
            DatiqFeatureFlagSelectors.areEnabled(featureFlagKeys),
        );
    }
    areEnabledSig(featureFlagKeys: string[]): Signal<boolean> {
        return this._store.selectSignal(
            DatiqFeatureFlagSelectors.areEnabled(featureFlagKeys),
        );
    }
    getFlagsSig(flgaNames: string[]): Signal<IDatiqFeatureFlag[]> {
        return this._store.selectSignal(
            DatiqFeatureFlagSelectors.getFlags(flgaNames),
        );
    }
    getAllEnabledFeatureFlags$(): Observable<IDatiqFeatureFlag[]> {
        return this._store.select(
            DatiqFeatureFlagSelectors.getAllEnabledFeatureFlags(),
        );
    }
    getEnabledVariables$(featureFlagKeys: string[]): Observable<unknown> {
        return this._store.select(
            DatiqFeatureFlagSelectors.getEnabledVariables(featureFlagKeys),
        );
    }

    getEnabledVariablesSig(featureFlagKeys: string[]): Signal<unknown> {
        return this._store.selectSignal(
            DatiqFeatureFlagSelectors.getEnabledVariables(featureFlagKeys),
        );
    }

    isLoaded$(): Observable<boolean> {
        return this._store.select(
            DatiqFeatureFlagSelectors.getDatiqFeatureFlagLoaded(),
        );
    }
    isLoadedSig(): Signal<boolean> {
        return this._store.selectSignal(
            DatiqFeatureFlagSelectors.getDatiqFeatureFlagLoaded(),
        );
    }

    getEnabledFlags$(featureFlags: string[]): Observable<IDatiqFeatureFlag[]> {
        return this._store.select(
            DatiqFeatureFlagSelectors.getEnabledFlags(featureFlags),
        );
    }
    getEnabledFlagListSig(featureFlags: string[]): Signal<IDatiqFeatureFlag[]> {
        return this._store.selectSignal(
            DatiqFeatureFlagSelectors.getEnabledFlags(featureFlags),
        );
    }
    getEnabledFlag$(featureFlag: string): Observable<IDatiqFeatureFlag> {
        return this._store.select(
            DatiqFeatureFlagSelectors.getEnabledFlag(featureFlag),
        );
    }
    getEnabledFlagSig(featureFlag: string): Signal<IDatiqFeatureFlag> {
        return this._store.selectSignal(
            DatiqFeatureFlagSelectors.getEnabledFlag(featureFlag),
        );
    }

    hasVariation$(featureFlag: string, variation: string): Observable<boolean> {
        return this._store.select(
            DatiqFeatureFlagSelectors.hasVariation(featureFlag, variation),
        );
    }
    hasVariationSig(featureFlag: string, variation: string): Signal<boolean> {
        return this._store.selectSignal(
            DatiqFeatureFlagSelectors.hasVariation(featureFlag, variation),
        );
    }
    dispatchEnrollExperimentFlag(flagName: string): void {
        this._store.dispatch(
            DatiqFeatureFlagActions.enrollExperimentFlag({ flagName }),
        );
    }
}
